import { cn } from "@/lib/cn";

type Props = {
  otherCount: number;
  view: "own" | "aggregated";
  onChange: (view: "own" | "aggregated") => void;
};

/** Alternador "Meus dados" / "Outras organizações" — usado nas telas de Pacientes, Prótese e
 *  Pedidos pra organização Pessoal que também possui (OWNER) outras organizações. Não aparece
 *  se não há outra organização própria pra agregar. */
export function OwnedOrgsViewToggle({ otherCount, view, onChange }: Props) {
  if (otherCount === 0) return null;

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-zinc-200 bg-zinc-50 p-1 dark:border-border dark:bg-muted/40">
      <ToggleButton label="Meus dados" active={view === "own"} onClick={() => onChange("own")} />
      <ToggleButton
        label={`Outras organizações (${otherCount})`}
        active={view === "aggregated"}
        onClick={() => onChange("aggregated")}
      />
    </div>
  );
}

function ToggleButton({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex h-8 items-center rounded-md px-2.5 text-[12.5px] font-semibold transition-colors",
        active
          ? "bg-brand-600 text-white shadow-sm"
          : "text-zinc-600 hover:text-zinc-900 dark:text-muted-foreground dark:hover:text-foreground",
      )}
    >
      {label}
    </button>
  );
}
